const localParams = 'LOCAL_PARAMS'
export default {
  // methods: {
  /**
   * 单页面跳页，不传参的话只写的一个name则可
   * @param name
   *      目标页面的 name
   *      注意：路由中的 name 和 path 须设同样字串,如(name: 'test', path: '/test')
   * @param params
   *      传递到目标页的参数
   * @param location
   *      记录一个位置信息，用于目标页获取到传递的参数
   * @param query
   *      传递到目标页的URL参数
   */
  pushPage (name, params, location, query) {
    params = params || {}
    query = query || {}
    if (location) {
      query.location = location
      sessionStorage.setItem(localParams + location, JSON.stringify(params))
    }
    this.$router.push({
      path: '/' + name,
      name: name,
      query: query
    })
  },
  /**
   * 打开新标签页条跳页，不传参的话只写的一个name则可
   * @param name
   *      目标页面的 name
   *      注意：路由中的 name 和 path 须设同样字串,如(name: 'test', path: '/test')
   * @param params
   *      传递到目标页的参数
   * @param query
   *      传递到目标页的URL参数
   */
  resolvePage (name, params, query) {
    params = params || {}
    query = query || {}
    window.open(this.$router.resolve({path: '/' + name, name: name, query: query}).href, '_blank')
  },
  /**
   * 可不跳页直接设参数
   * @param params
   * @param location
   */
  setParams (params, location) {
    if (location) {
      params = params || {}
      sessionStorage.setItem(localParams + location, JSON.stringify(params))
    }
  },
  /**
   * 目标页获取参数的方法
   * @param location
   * @param redirect
   * @param redirect
   *  重定向的页面 name，当获取的参数的空时，则重定向到 redirect 页面。
   *  @param query  重定向时的 query 参数，无则不传
   * @returns {{}}
   */
  getParams (location, redirect, query) {
    if (location) {
      let params = sessionStorage.getItem(localParams + location)
      if (params) {
        return JSON.parse(params)
      } else if (redirect) {
        query = query || {}
        this.pushPage(redirect, null, null, query)
        return null
      } else {
        return null
      }
    } else return null
  },

  // ==============================================================
  /**
   * 新窗口跳页,如不需传参，则只写 name
   * @param name   新页的 name。
   * @param id     不重复的 id，这个 id 在新页的取 data 值使用。
   * @param data   需传递的数据，对象类型。
   */
  openWindow (name, id, data) {
    id = 'content' + id
    let input = document.getElementById(id)
    if (input) input.value = ''
    else {
      input = document.createElement('input')
    }
    if (id && data) {
      input.id = id
      input.type = 'hidden'
      input.name = 'content'
      input.value = JSON.stringify(data)
      document.body.appendChild(input)
    }
    window.open(window.location.origin + '#/' + name)
    // window.open(window.location.origin + '/' + name)
  },
  /**
   * openWindow(name, id, data)  打开的新窗口使用这个方法获取 data。
   * @param id  openWindow() 方法中传入的 id。
   * @returns {{}}
   */
  getOpenWindowData (id) {
    id = 'content' + id
    let input = window.opener.document.getElementById(id)
    if (input) {
      let val = input.value
      if (val) return JSON.parse(val)
      else return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/basePage.js